import React, { FC } from 'react'
import { StyledHeadline } from './PageHeadline.style'

interface PageHeadlineProps {
  children?: React.ReactNode
}

export const PageHeadline: FC<PageHeadlineProps> = ({ children }) => <StyledHeadline>{children}</StyledHeadline>
